import { render, staticRenderFns } from "./LogoMenu_111.vue?vue&type=template&id=579d965a&"
import script from "./LogoMenu_111.vue?vue&type=script&lang=js&"
export * from "./LogoMenu_111.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports